module.exports = __webpack_public_path__ + "static/media/fftpubtheme.a66f99c5.mp3";